var option_webview_default = {
  "option": "DnOtU",
  "user_choice": "OvKM8",
  "check": "ci9nz",
  "image": "_6UNY7",
  "input": "xdg22",
  "title": "hbkXw",
  "centered": "CJe-9",
  "with_result": "SWy66",
  "list": "QRF-z",
  "with_image": "jUWfA",
  "progress": "tIPmW",
  "progress_value": "z0ocH",
  "label": "iX5Js",
  "cta": "u2vx8",
  "adornment_icon": "xYSYG",
  "remove": "nk9g2",
  "removeButton": "D14pC",
  "removeButtonIcon": "rvJmn",
  "overlay": "HSpUD",
  "shown": "_8rdCx",
  "dark": "cwBKu",
  "spinner": "-YTBI",
  "spin": "BoRmR",
  "grid": "AZSD1"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
